export default {
  title: 'Up',
};
